import React, { useState } from "react";
import { Collapse } from "react-collapse";
import { Table } from "antd";
import { ArrowClosed, Close } from "assets/icons";
import { IItemsCheckinDataTable } from "store/attendance/attendance-model";
import useTranslation from "utils/hooks/useTranslation";
import * as S from "../index.styled";
import columnsTable from "./columnsTable";

export interface IItemContent {
  itemsCheckin?: IItemsCheckinDataTable[];
}

const ItemContent = ({ itemsCheckin }: IItemContent): JSX.Element => {
  const [expandedPanels, setExpandedPanels] = useState([]);
  const ITEMS_TITLE = useTranslation({ id: "item_title" });
  const ITEMS_DESCRIPTION = useTranslation({ id: "item_description" });
  const THERE_ARE_NO_ITEMS = useTranslation({ id: "there_are_no_items_for_this_checkin" });

  const isPanelExpanded = (panelKey) => {
    return expandedPanels.includes(panelKey);
  };

  const handlePanelClick = (panelKey: string) => {
    if (isPanelExpanded(panelKey)) {
      setExpandedPanels((prevExpanded) => prevExpanded.filter((key) => key !== panelKey));
    } else {
      setExpandedPanels((prevExpanded) => [...prevExpanded, panelKey]);
    }
  };

  return (
    <>
      {itemsCheckin?.length > 0 ? (
        <>
          <S.ItemHeader>
            <S.ItemTitle>{ITEMS_TITLE}</S.ItemTitle>
            <S.ItemDescription>{ITEMS_DESCRIPTION}</S.ItemDescription>
          </S.ItemHeader>
          {itemsCheckin?.map((item) => (
            <S.DocumentContainer key={item.documentNumber}>
              <S.Document isActive={isPanelExpanded(item.documentNumber)}>
                <S.DocumentNumber onClick={() => handlePanelClick(item.documentNumber)}>
                  <S.DocumentTitle>{item.documentNumber}</S.DocumentTitle>
                  {isPanelExpanded(item.documentNumber) ? <Close /> : <ArrowClosed />}
                </S.DocumentNumber>
                <div className="divider" />
              </S.Document>
              <Collapse isOpened={isPanelExpanded(item.documentNumber)}>
                <S.ItemsTable>
                  <Table columns={[...columnsTable()]} dataSource={item.orderItems} rowKey="id" style={{ whiteSpace: "pre-wrap" }} pagination={false} />
                </S.ItemsTable>
              </Collapse>
            </S.DocumentContainer>
          ))}
        </>
      ) : (
        <S.WithoutDocumentContainer>
          <S.DocumentTitle>{THERE_ARE_NO_ITEMS}</S.DocumentTitle>
        </S.WithoutDocumentContainer>
      )}
    </>
  );
};

export default ItemContent;
